import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _eabd07fa = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _066288a2 = () => interopDefault(import('../pages/download-app/index.vue' /* webpackChunkName: "pages/download-app/index" */))
const _5e75dbe8 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _ab890f10 = () => interopDefault(import('../pages/manage/index.vue' /* webpackChunkName: "pages/manage/index" */))
const _9cadd2bc = () => interopDefault(import('../pages/manage-your-subscription/index.vue' /* webpackChunkName: "pages/manage-your-subscription/index" */))
const _27596b6c = () => interopDefault(import('../pages/reset-password/index.vue' /* webpackChunkName: "pages/reset-password/index" */))
const _e52ac3ee = () => interopDefault(import('../pages/upsells/index.vue' /* webpackChunkName: "pages/upsells/index" */))
const _eea0b74a = () => interopDefault(import('../pages/login/app.vue' /* webpackChunkName: "pages/login/app" */))
const _e12205ea = () => interopDefault(import('../pages/login/authenticate.vue' /* webpackChunkName: "pages/login/authenticate" */))
const _699a35b6 = () => interopDefault(import('../pages/manage/cancel-subscription.vue' /* webpackChunkName: "pages/manage/cancel-subscription" */))
const _793507f4 = () => interopDefault(import('../pages/manage/something-went-wrong/index.vue' /* webpackChunkName: "pages/manage/something-went-wrong/index" */))
const _62669367 = () => interopDefault(import('../pages/manage/subscription.vue' /* webpackChunkName: "pages/manage/subscription" */))
const _0d0c94d6 = () => interopDefault(import('../pages/manage/thanks/index.vue' /* webpackChunkName: "pages/manage/thanks/index" */))
const _19033daa = () => interopDefault(import('../pages/manage/update-credit-card.vue' /* webpackChunkName: "pages/manage/update-credit-card" */))
const _04752e21 = () => interopDefault(import('../pages/manage/app/login.vue' /* webpackChunkName: "pages/manage/app/login" */))
const _fa2385dc = () => interopDefault(import('../pages/manage/app/magic-link.vue' /* webpackChunkName: "pages/manage/app/magic-link" */))
const _93d4e1da = () => interopDefault(import('../pages/manage/app/request-password-reset.vue' /* webpackChunkName: "pages/manage/app/request-password-reset" */))
const _043152d1 = () => interopDefault(import('../pages/manage/app/reset-password.vue' /* webpackChunkName: "pages/manage/app/reset-password" */))
const _51c85ed7 = () => interopDefault(import('../pages/contact/components/contact/contact.vue' /* webpackChunkName: "pages/contact/components/contact/contact" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b19b8c4c = () => interopDefault(import('../pages/manage/something-went-wrong/__components/SomethingWentWrongContent/SomethingWentWrongContent.vue' /* webpackChunkName: "pages/manage/something-went-wrong/__components/SomethingWentWrongContent/SomethingWentWrongContent" */))
const _3706470c = () => interopDefault(import('../pages/manage/thanks/__components/ThankYouContent/ThankYouContent.vue' /* webpackChunkName: "pages/manage/thanks/__components/ThankYouContent/ThankYouContent" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact",
    component: _eabd07fa,
    name: "contact"
  }, {
    path: "/download-app",
    component: _066288a2,
    name: "download-app"
  }, {
    path: "/login",
    component: _5e75dbe8,
    name: "login"
  }, {
    path: "/manage",
    component: _ab890f10,
    name: "manage"
  }, {
    path: "/manage-your-subscription",
    component: _9cadd2bc,
    name: "manage-your-subscription"
  }, {
    path: "/reset-password",
    component: _27596b6c,
    name: "reset-password"
  }, {
    path: "/upsells",
    component: _e52ac3ee,
    name: "upsells"
  }, {
    path: "/login/app",
    component: _eea0b74a,
    name: "login-app"
  }, {
    path: "/login/authenticate",
    component: _e12205ea,
    name: "login-authenticate"
  }, {
    path: "/manage/cancel-subscription",
    component: _699a35b6,
    name: "manage-cancel-subscription"
  }, {
    path: "/manage/something-went-wrong",
    component: _793507f4,
    name: "manage-something-went-wrong"
  }, {
    path: "/manage/subscription",
    component: _62669367,
    name: "manage-subscription"
  }, {
    path: "/manage/thanks",
    component: _0d0c94d6,
    name: "manage-thanks"
  }, {
    path: "/manage/update-credit-card",
    component: _19033daa,
    name: "manage-update-credit-card"
  }, {
    path: "/manage/app/login",
    component: _04752e21,
    name: "manage-app-login"
  }, {
    path: "/manage/app/magic-link",
    component: _fa2385dc,
    name: "manage-app-magic-link"
  }, {
    path: "/manage/app/request-password-reset",
    component: _93d4e1da,
    name: "manage-app-request-password-reset"
  }, {
    path: "/manage/app/reset-password",
    component: _043152d1,
    name: "manage-app-reset-password"
  }, {
    path: "/contact/components/contact/contact",
    component: _51c85ed7,
    name: "contact-components-contact-contact"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }, {
    path: "/manage/something-went-wrong/:_components?/SomethingWentWrongContent/SomethingWentWrongContent",
    component: _b19b8c4c,
    name: "manage-something-went-wrong-_components-SomethingWentWrongContent-SomethingWentWrongContent"
  }, {
    path: "/manage/thanks/:_components/ThankYouContent/ThankYouContent",
    component: _3706470c,
    name: "manage-thanks-_components-ThankYouContent-ThankYouContent"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
